import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';

const ClientTransactionSuccess = ({ title, icon, description, onReset }) => {
  const t = useTranslation();

  useEffect(() => {
    setTimeout(() => onReset?.(), Config.main.clientTransactionSuccessStateDelay * 1000);
  }, []);

  return (
    <div className="ct-form ct-form-success">
      <h3 className="ct-form-title">{t(title)}</h3>
      <i className={`ct-form-icon global-icon ${icon}`} />
      <p className="ct-form-subtitle">{t(description)}</p>
    </div>
  );
};

ClientTransactionSuccess.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onReset: PropTypes.func,
};

export default ClientTransactionSuccess;
